import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics";

// Fires a GA4 page_view event AND scrolls to the top whenever the route changes.
// Without the scroll, clicking About/Contact/Shipping from the footer would
// leave the viewport at its previous scroll position.
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Jump to top on every route change (unless the URL has a hash target)
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    // Wait a tick so document.title reflects the new page
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search, location.hash]);
  return null;
};

export default RouteTracker;
